<template>
  <div class="login-page">
    <div class="login-card">
      <router-link to="/" class="login-brand" aria-label="Bati Vision 360 home">
        <img src="/apple-touch-icon.png" alt="Bati Vision 360" />
      </router-link>

      <div v-if="isLoading" class="login-loading">
        <div class="loading-spinner"></div>
        <p>{{ $t('common.loading') }}</p>
      </div>
      <div v-if="errorMessage" class="login-error">
        {{ errorMessage }}
        <router-link to="/">
          <AppButton variant="outline">{{ $t('common.backToHome') }}</AppButton>
        </router-link>
      </div>
      <div class="login-forgot" v-if="!isLoading">
        <router-link to="/reset-password" class="forgot-password-link">{{ $t('auth.forgotPassword') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/// <reference types="vue" />
// @ts-ignore
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import archiWebAuthService from '../services/archiweb.auth.service'
import AppButton from './base/AppButton.vue'

const router = useRouter()
const isLoading = ref(true)
const errorMessage = ref<string | null>(null)

onMounted(async () => {
  try {
    await archiWebAuthService.login()
    // On success, redirect to user home or dashboard
    router.push('/')
  } catch (error) {
    console.error('Auto-login failed:', error)
    errorMessage.value = 'Failed to start login process'
    isLoading.value = false
  }
})
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--background-primary);
}

.login-card {
  display: flex;
  width: min(100% - 2rem, 420px);
  flex-direction: column;
  align-items: center;
  gap: var(--space-lg);
}

.login-brand {
  display: block;
  line-height: 0;
  filter: drop-shadow(0 10px 24px rgba(3, 31, 55, 0.18));
}

.login-brand img {
  display: block;
  width: 180px;
  height: 180px;
  object-fit: contain;
}

.login-forgot {
  margin-top: 2rem;
  text-align: center;
}
.forgot-password-link {
  color: var(--primary);
  text-decoration: underline;
  cursor: pointer;
  font-size: 1rem;
}

.login-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-md);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--neutral-200);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.login-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-md);
  text-align: center;
  background: var(--error-background);
  color: var(--error);
  padding: var(--space-lg);
  border-radius: var(--radius-md);
  border: 1px solid var(--error-alpha-20);
  max-width: 400px;
}

@media (max-width: 480px) {
  .login-brand img {
    width: 140px;
    height: 140px;
  }
}
</style>
